import { post } from "./Api";

export function SearchBingoDetail({ data }) {
  return post({ url: `/api/v1/haire/bingo/detail` , data});
}

export function SearchBingoCardById({ data }) {
  return post({ url: `/api/v1/haire/bingocard/detail` , data});
}

export function InsertCardActivity({ data }) {
  return post({ url: `/api/v1/haire/bingo/card/history/insert` , data});
}

export function InsertBingo({ data }) {
  return post({ url: `/api/v1/haire/bingo/history/insert` , data});
}

export function SearchPrizeBingo({ data }) {
  return post({ url: `/api/v1/haire/member/search/prizebingo` , data});
}






